<template>
  <div class="cart fixed bottom-0 z-10 w-full flex" :class="{ ' top-0': showItems }"
    v-if="this.$store.state.cart.active">
    <!--    v-if="this.$store.state.cart.active"-->
    <div class="mx-4 mt-4 flex flex-col w-full shadow-hard">

      <div class="cart__items p-5 lg:p-10 bg-white overflow-scroll flex-1 relative" v-if="showItems">
        <a @click="showItems = false"
          class="absolute top-0 right-0 bg-gray-400 px-6 py-3 font-bold flex items-center cursor-pointer">Close
          <font-awesome-icon :icon="['far', 'times']" class="ml-2 text-xl" />
        </a>
        <h2 class=" text-3xl font-bold mb-4 inline-block">Your Basket</h2>
        <a @click="clearCart()" class="block lg:inline-block lg:ml-5 underline cursor-pointer" v-if="itemsAmount">Clear
          basket</a>
        <p v-if="!itemsAmount"><i>Please add some products to cart.</i></p>
        <table class="w-full" v-else>
          <tr class="border-b border-gray-700">
            <th class="hidden md:block"></th>
            <th class="text-left py-4">Product</th>
            <th class="text-center py-4">Quantity</th>
            <th class="text-center py-4">Delete</th>
          </tr>
          <tr v-for="item in items" :key="item.part_no" class="border-b ">
            <td class="hidden md:block py-4 align-middle justify-center ">
              <img :src="item.picture" :alt="item.description" class="block w-32" v-if="item.picture">
              <img src="/images/placeholder.jpg" class="block w-32" v-else>
            </td>
            <td class="py-4">
              <div class="lg:flex">
                <div class="lg:flex items-center lg:mr-10 font-semibold text-base lg:text-lg flex-1">
                  {{ item.description }}
                </div>
                <div class="lg:flex flex-col items-center lg:w-1/4">
                  <div>
                    <span class="lg:w-32 inline-block">IMPA Code:</span> <span class=" font-semibold font-mono">{{
      item.part_no }}</span><br>
                    <span class="lg:w-32 inline-block">UOM:</span> <span class=" font-semibold font-mono">{{
      item.uom
    }}</span><br>
                    <span class="lg:w-32 inline-block">MTML UOM:</span> <span class=" font-semibold font-mono">{{
        item.mtml_uom }}</span>
                  </div>
                </div>
              </div>
            </td>
            <td class="py-4 text-center">
              <input :value="item.quantity" type="number" @change="event => modifyItemQuantity(event, item.part_no)"
                class="text-center text-xl md:text-6xl font-bold w-20 md:w-40">
            </td>
            <td class="py-4 text-center">
              <button @click="removeItem(item.part_no)">
                <font-awesome-icon :icon="['far', 'times']" class="text-3xl" />
              </button>
            </td>
          </tr>
        </table>
      </div>

      <div class="cart__status lg:flex items-center justify-between bg-gray-100 lg:h-20 flex-shrink-0 flex-grow-0 p-4">
        <div class=" mb-4 lg:mb-0">

          <span class="cart-amount bg-msgblue-dark text-white rounded-full inline-block text-center mr-2 cursor-pointer"
            style="line-height:30px;min-width:30px;" @click="showItems = !showItems"
            :class="{ 'cart-amount-animate': totalAnimating }">
            {{ itemsAmount }}
          </span>
          <span class="hidden lg:inline-block">items in your enquiry basket.</span>
          <a @click="showItems = !showItems" class="cursor-pointer font-bold underline ml-1">View basket</a>
        </div>

        <div class="flex" v-if="itemsAmount">
          <div class="button flex align-middle mr-2 cursor-pointer" v-if="$store.state.user.ihm" @click="ihmCheck()">
            <div v-if="ihmLoading">
              <font-awesome-icon :icon="['far', 'spinner-third']" class="text-xl mr-2 spin" />
            </div>
            <div v-if="!ihmLoading">
              <font-awesome-icon :icon="['fas', 'check']" class="text-xl mr-2" />
              <span>IHM Check</span>
            </div>
          </div>

          <download-csv :data="this.getData()" :advancedOptions="{
      quotes: false,
      escapeChar: '',
      quoteChar: ''
          }" class="button button--green flex align-middle cursor-pointer text-center">
            <font-awesome-icon :icon="['far', 'file-download']" class="text-xl mr-2" />
            <span>
              Export CSV
            </span>
          </download-csv>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
export default {
  data: function () {
    return {
      showItems: false,
      totalAnimating: false,
      ihmLoading: false
    }
  },
  computed: {
    items: function () {
      return this.$store.state.cart.items
    },
    itemsAmount: function () {
      return this.$store.state.cart.items.length
    }
  },
  watch: {
    items: function () {
      this.animateTotal()
    }
  },
  methods: {
    modifyItemQuantity: function (event, itemCode) {
      this.$store.dispatch('cart/modifyItemQuantity', {
        part_no: itemCode,
        quantity: event.target.value
      })
    },
    removeItem: function (id) {
      this.$store.dispatch('cart/removeItemFromCart', id)
    },
    clearCart: function () {
      this.$store.dispatch('cart/clearCart')
    },
    animateTotal: function () {
      setTimeout(function () {
        this.totalAnimating = false;
      }.bind(this), 10)
      setTimeout(function () {
        this.totalAnimating = true;
      }.bind(this), 20)
    },
    getData: function () {
      const csvData = [];
      this.items.forEach(function (product) {
        if (product.quantity > 0) {
          csvData.push({
            'IMPA code': '"=""' + product.part_no + '"""',
            'Description': '"' + product.description + '"',
            'UOM': product.uom,
            'MTML UOM': product.mtmlUom,
            'Quantity': product.quantity
          })
        }
      });
      this.$ga.event({
        eventCategory: 'Export',
        eventAction: 'csv'
      })
      return csvData;
    },
    ihmCheck: function () {


      const articles = [];
      var ihmData = [];

      this.items.forEach(function (product) {
        if (product.quantity > 0) {
          articles.push({
            'extid': product.id ? String(product.id) : null,
            'name': product.description,
            'description': product.explanation,
            'impa_number': String(product.part_no),
          })
        } else {
          alert('Cart is empty.')
        }
      });

      var ihmData = {
        'user_extid': this.$store.state.user.id ? String(this.$store.state.user.id) : null,
        'user_email': this.$store.state.user.email,
        'user_company': this.$store.state.user.company,
        'user_firstname': this.$store.state.user.firstName,
        'user_lastname': this.$store.state.user.lastName,
        'articles': articles,
      }

      if (!this.ihmLoading) {
        this.ihmLoading = true;

        this.$http.post('/actions/api-proxy-module/default/ihm', ihmData)
          .then((response) => {
            this.ihmLoading = false;
            // console.log(response);
            if (response.data.data || response.data.success) {
              this.$toast.success("IHM relevancy check submitted successfully.");
            } else {
              this.ihmLoading = false;
              if (response.data.error.code) {
                this.$toast.error('Error: ' + response.data.error.code + ' ' + response.data.error.details);
              } else {
                this.$toast.error('Could not complete IHM relevancy check.');
              }
            }
          })
          .catch(error => {
            this.ihmLoading = false;
            this.$toast.error('Could not complete IHM relevancy check.');
          });
      }
    }
  }
}
</script>

<style>
.animated {
  display: none;
}

.cart-amount {
  transition: all;
  transform: scale(1);
}

.cart-amount-animate {
  animation-name: cart-amount-pop;
  animation-duration: 1s;
}

@keyframes cart-amount-pop {
  0% {
    transform: scale(1)
  }

  50% {
    transform: scale(1.5)
  }

  100% {
    transform: scale(1)
  }
}
</style>